import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DynamicRenderSharedModule } from '../../shared/shared.module';
import { ValidationsModule } from '../../validations/validations.module';

import { CardHeaderComponent } from './card-header/card-header.component';
import { CardValidationComponent } from './card-validation/card-validation.component';
import { CardFieldsComponent } from './card-fields/card-fields.component';
import { CoreCardBaseComponent } from './core-card-base.component';
import { CoreBuildingBlockModule } from '../../building-block/core-building-block.module';
import { CardFooterComponent } from './card-footer/card-footer.component';

const components = [CoreCardBaseComponent, CardHeaderComponent, CardFooterComponent, CardValidationComponent, CardFieldsComponent];
@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, ValidationsModule, CoreBuildingBlockModule, DynamicRenderSharedModule]
})
export class CardSharedModule {}
